<template>
  <div class="warp">
    <p class="backpage">
      <i class="el-icon-back" @click="Backyzm"></i>
      <i class="el-dialog__close el-icon el-icon-close" @click="Backyzm"></i>
    </p>
    <div class="VerificationCode">
      <h3 class="title">验证手机号</h3>
      <div class="input_all">
        <el-input @change="phone_judgment" class="input" placeholder="请输入手机号" v-model="shuru.phone"></el-input>
        <span class="promp">{{ cuowuspan.phone }}</span>
        <!-- 获取验证码部分 -->
        <el-input
          @change="Verificationa"
          class="input"
          placeholder="输入验证码"
          v-model="shuru.Verification"
        ></el-input>
        <span class="promp">{{ cuowuspan.Verification }}</span>

        <el-button
          :disabled="disabled || shuru.phone.length != 11"
          class="GetCerificationCode"
          @click="GetCerificationCode"
          :class="
            shuru.phone.length != 11
              ? 'GetCerificationCode'
              : sends != '获取验证码'
              ? 'GetCerificationCode'
              : 'Obtain'
          "
        >{{ sends }}</el-button>
      </div>

      <el-button
        class="btn_next"
        @click="NextStep"
        :style="
          shuru.phone && shuru.Verification != ''
            ? 'background-image: linear-gradient(270deg, #f4c91d 0%, #fff282 100%); color:black; border: 1px solid rgb(228 195 51);'
            : ''
        "
      >下一步</el-button>
    </div>
    <div class="ResetPassword" v-show="BackIdentifying_D">
      <p class="backpage">
        <i class="el-icon-back" @click="BackIdentifying"></i>
      </p>
      <div class="content">
        <h3 class="title">重置密码</h3>
        <el-input
          @change="FirstInput"
          class="input"
          placeholder="请输入您的密码"
          v-model="shuru.password"
          show-password
          maxlength="25"
          minlength="25"
        ></el-input>

        <span class="promp">{{ cuowuspan.password_Verification }}</span>
        <div class="three_origin">
          <div>
            <div class="origin">
              <span :class="{ curral: /\d/.test(shuru.password) }"></span>密码中包含数字
            </div>
            <div class="origin">
              <span :class="{ curral: /[a-zA-Z]/g.test(shuru.password) }"></span>密码中包含字母
            </div>
          </div>
          <div class="origin">
            <span
              :class="{
                curral: /^[0-9a-zA-Z_]{8,25}$/.test(shuru.password),
              }"
            ></span>8-25位密码且没有特殊字符
          </div>
        </div>
        <el-input
          @change="SecondInput"
          class="input isinput"
          placeholder="请确认您的密码"
          v-model="shuru.password_two"
          show-password
          maxlength="25"
          minlength="25"
        ></el-input>
        <span class="promp">{{ cuowuspan.password_Verification_two }}</span>
      </div>
      <el-button
        class="btn_next"
        @click="ConfirmChangePassword"
        :style="
          shuru.password && shuru.password_two != ''
            ? 'background-image: linear-gradient(270deg, #f4c91d 0%, #fff282 100%); color:black; border: 1px solid rgb(228 195 51);'
            : ''
        "
      >完成</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      Back_yzm: false,
      // 输入的数据
      shuru: {
        phone: '',
        Verification: '', // 验证码

        password: '',
        password_two: '',
        // 中级密码
        FinalPassword: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: '',
        // 设置密码
        password_Verification: '',
        password_Verification_two: '',
        password: '',
        password_two: ''
      },
      // 发送验证码按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,

      // 重置密码框显示隐藏
      BackIdentifying_D: false,
      // 是否可以执行下一步
      NextStep_D: false
    }
  },
  methods: {
    // 判断两次密码正确性
    FirstInput () {
      if (this.shuru.password == '') {
        this.cuowuspan.password_Verification = '密码不能为空'
      } else if (this.shuru.password) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
        if (reg.test(this.shuru.password)) {
          if (this.shuru.password == this.shuru.password_two || this.shuru.password_two == '') {
            this.cuowuspan.password_Verification = ''
            this.cuowuspan.password_Verification_two = ''
          } else if (this.shuru.password == this.shuru.password_two || this.shuru.password_two != '') {
            this.cuowuspan.password_Verification = '两次输入密码不一致'
          }
        } else {
          this.cuowuspan.password_Verification = '密码格式有误'
        }
      }
      if (this.shuru.password == this.shuru.password_two) {
        this.shuru.FinalPassword = this.shuru.password
      } else {

      }
    },
    // 设置密码 ,第二个密码填写框
    SecondInput () {
      if (this.shuru.password_two != this.shuru.password) {
        if (this.shuru.password == '') {
          this.cuowuspan.password_Verification_two = ''
        } else if (this.shuru.password_two != this.shuru.password || this.shuru.password != '') {
          this.cuowuspan.password_Verification_two = '两次输入密码不一致'
        }
      } else if (this.shuru.password_two == this.shuru.password) {
        this.shuru.FinalPassword = this.shuru.password
        this.cuowuspan.password_Verification_two = ''
      }
    },
    // 返回收取验证码界面
    BackIdentifying () {
      this.BackIdentifying_D = false

      this.shuru.phone = ''
      this.shuru.Verification = ''
      this.shuru.password = ''
      this.shuru.password_two = ''
      this.shuru.FinalPassword = ''
      this.cuowuspan.phone = ''
      this.cuowuspan.Verification = ''
      this.cuowuspan.password_Verification = ''
      this.cuowuspan.password_Verification_two = ''
      this.cuowuspan.password = ''
      this.cuowuspan.password_two = ''
    },
    Backyzm () {
      this.$emit('backyzm', this.Back_yzm)
      this.BackIdentifying_D = false
      this.shuru.phone = ''
      this.shuru.Verification = ''
      this.shuru.password = ''
      this.shuru.password_two = ''
      this.shuru.FinalPassword = ''
      this.cuowuspan.phone = ''
      this.cuowuspan.Verification = ''
      this.cuowuspan.password_Verification = ''
      this.cuowuspan.password_Verification_two = ''
      this.cuowuspan.password = ''
      this.cuowuspan.password_two = ''
    },
    // 判断手机号是否正确
    phone_judgment () {
      if (this.shuru.phone == '') {
        // this.phonea = true
        this.cuowuspan.phone = '请填写手机号'
        // this.yzmIcon = 'el-icon-error'
        // this.flag=false
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          // this.phone = false
          this.cuowuspan.phone = ''
          // this.yzmIcon = 'el-icon-success'
        } else {
          // this.phonea = true
          this.cuowuspan.phone = '手机号格式有误'
          // this.yzmIcon = 'el-icon-error'
          return false
        }
      }
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.cuowuspan.Verification = ''
        } else {
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    GetCerificationCode () {
      // 发送验证码
      if (this.shuru.phone == '') {
        this.cuowuspan.phone = '请填写手机号'
        return false
      } else {
        this.http.yzpho(this.shuru.phone).then(res => {
          console.log(res)
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              this.cuowuspan.phone = '该账户不存在'
            } else if (res.data.message == 'true') {
              this.http
                .send(this.shuru.phone)
                .then(res => {
                  console.log(res)
                  if (res.data.code == 200) {
                    if (res.data.message == 'ok') {
                      this.Changebutton = 1
                      this.$message({
                        message: '验证码已发送到您的手机，请注意查看',
                        type: 'success'
                      })
                      var that = this
                      var resend = setInterval(function () {
                        that.sendstime--
                        if (that.sendstime > 0) {
                          that.sends = that.sendstime + 's后重新获取'
                          that.disabled = true
                        } else {
                          clearInterval(resend)
                          that.sends = '获取验证码'
                          that.sendstime = 60
                          that.disabled = false
                        }
                      }, 1000)
                    }
                  } else if (res.data.code == 400) {
                    if (res.data.message == 'failed,unable to get data') {
                      this.$message.error('不能获取到数据')
                    } else if (res.data.message == 'failed,user phone invalid') {
                      this.$message.error('手机号无效')
                    }
                  } else if (res.data.code == 500) {
                    if (res.data.message == 'failed,please retry!') {
                      this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
                    }
                  } else if (res.data.code == 403) {
                    this.$message.error('验证码发送过于频繁，请稍后再重新尝试!')
                  }
                })
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
          }
        })
      }
    },
    NextStep () {
      if (this.shuru.phone.length != 11) {

      } else if (this.shuru.phone.length == 11) {
        // console.log(typeof this.shuru.phone,typeof this.shuru.Verification)
        this.http.checkPhone(this.shuru.phone, this.shuru.Verification)
          .then(res => {
            // this.BackIdentifying_D = true
            if (res.data.code == 400) {
              this.$message.error('账号或验证码错误，请检查')
            } else if (res.data.code == 200) {
              this.BackIdentifying_D = true
            }
          })
      }
    },
    // 确认修改密码请求
    ConfirmChangePassword () {
      console.log(this.cuowuspan)
      if (
        this.shuru.phone &&
        this.shuru.Verification &&
        this.shuru.FinalPassword != '' &&
        this.shuru.phone.length == 11 &&
        this.shuru.Verification.length == 6 &&
        this.shuru.password == this.shuru.password_two &&
        this.shuru.password == this.shuru.FinalPassword &&
        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/.test(this.shuru.FinalPassword)
      ) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
        if (reg.test(this.shuru.FinalPassword)) {
          this.http
            .xgpass(this.shuru.phone, this.shuru.Verification, this.shuru.FinalPassword)
            .then(res => {
              if (res.data.code == 200) {
                if (res.data.message == 'ok') {
                  this.$message({
                    message: '修改成功，快去登录吧！',
                    type: 'success'
                  })
                  this.$emit('backyzm', this.Back_yzm)
                  this.shuru.phone = ''
                  this.shuru.Verification = ''
                  this.shuru.password = ''
                  this.shuru.password_two = ''
                  this.shuru.FinalPassword = ''
                  this.cuowuspan.phone = ''
                  this.cuowuspan.Verification = ''
                  this.cuowuspan.password_Verification = ''
                  this.cuowuspan.password_Verification_two = ''
                  this.cuowuspan.password = ''
                  this.cuowuspan.password_two = ''
                  this.BackIdentifying_D = false
                }
              }
            })
            .catch(err => {
              this.$message.error('验证码填写错误')
            })
        } else {
          this.$message.error('请注意密码规范')
        }
      } else {
        this.$message.error('请检查您的手机号码或密码或验证码')
      }
    }
  },
  mounted () {},
  watch: {
    'shuru.password': function () {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
      if (this.shuru.password == this.shuru.password_two && reg.test(this.shuru.password)) {
        this.NextStep_D = true
        this.shuru.FinalPassword = this.shuru.password
        this.cuowuspan.password_Verification = ''
        this.cuowuspan.password_Verification_two = ''
      } else if (this.shuru.password != this.shuru.password_two) {
        this.NextStep_D = false
      }

      if (this.shuru.password_two == '' && this.shuru.password == '') {
        this.cuowuspan.password_Verification_two = ''
        this.cuowuspan.password_Verification = '密码不能为空'
      }
    },
    'shuru.password_two': function () {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
      if (this.shuru.password == this.shuru.password_two && reg.test(this.shuru.password)) {
        this.NextStep_D = true
        this.shuru.FinalPassword = this.shuru.password
        this.cuowuspan.password_Verification = ''
        this.cuowuspan.password_Verification_two = ''
      } else if (this.shuru.password != this.shuru.password_two) {
        this.NextStep_D = false
      }

      if (this.shuru.password_two == '' && this.shuru.password == '') {
        this.cuowuspan.password_Verification_two = ''
        this.cuowuspan.password_Verification = '密码不能为空'
      }
    }
  }
}
</script>
<style scoped>
.warp {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px 20px 20px 20px;
}
.backpage {
  width: 100%;
  height: 25px;
}
.backpage i {
  display: block;
  float: left;
  color: white;
  height: 100%;
  text-align: center;
  width: 50px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 18px;
  line-height: 18px;
  padding: 3.5px 0 3.5px 0;
}
.backpage i:nth-child(2) {
  float: right;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  line-height: 32px;
  text-align: center;
  padding: 0;
  position: relative;
  z-index: 20;
}
.backpage i:hover {
  background-color: #6767676e;
}
.title {
  height: 40px;
  width: 100%;
  user-select: none;
  font-size: 30px;
  color: white;
  font-weight: 900;
  overflow: hidden;
  font-family: Noto Sans S Chinese Black Bold;
}
.VerificationCode {
  position: relative;
  width: 100%;
  height: 300px;
  margin-top: 45px;
}
.input_all input {
  padding-bottom: 50px;
}
.input {
  display: block !important;
  margin: 0 auto !important;
  width: 237px !important;
  border-style: none !important;
  /* border-bottom: 1px solid #ffffff5c !important; */
  font-size: 12px !important;
  caret-color: #f4c91d !important;
  background-color: transparent !important;
  height: 40px;
  color: white;
}
.promp {
  display: block;
  font-size: 10px;
  color: #f56c6c;
  margin: 0 auto;
  width: 237px;
  height: 12px;
  margin-bottom: 20px;
}
.GetCerificationCode {
  padding-right: 15px !important;
  line-height: 0px !important;
  color: #ffffff8a;
  height: 26px;
  position: absolute;
  top: 134px;
  right: 42px;
  background-color: #a6a9af !important;
  border-color: #a6a9af !important;
}
.Obtain {
  padding-right: 15px !important;
  line-height: 0px !important;
  color: black !important;
  height: 26px;
  position: absolute;
  top: 134px;
  right: 42px;
  font-size: 14px;
  background-image: linear-gradient(
    270deg,
    rgba(244, 201, 29, 1) 0%,
    rgba(255, 242, 130, 1) 100%
  );
}
.btn_next {
  width: 237px;
  height: 40px;
  background-color: #a6a9af;
  border: 1px solid #a6a9af;
  color: #ffffff8a;
  display: block;
  margin: 30px auto 0;
}
.ResetPassword {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #252e45;
  border-radius: 20px;
  padding: 20px 20px 20px 20px;
}
.content {
  margin-top: 35px;
}
.content div {
  width: 237px;
}
.three_origin {
  height: 75px;
  margin: 0 auto;
}
.three_origin div {
  height: 35px;
  color: white;
  font-size: 10px;
  float: left;
}
.three_origin div {
  display: flex;
  align-items: center;
}
.origin span {
  display: inline-block !important;
  border-radius: 50px;
  background-color: red;
  width: 12px;
  height: 12px;
  margin-right: 5px !important;
}
.isinput {
  margin-top: 20px !important;
}
.curral {
  background-color: greenyellow !important;
  transition-duration: 0.6s;
}
</style>



// WEBPACK FOOTER //
// src/base/ResetPassword.vue